import { Routes } from '@angular/router';
import { authGuard } from '@core/auth/auth.guard';
import { APP_ROUTES } from '@core/constants/routes.constants';
import { authRoutes } from './features/auth/routes';
import { evaluationsRoutes } from './features/evaluations/routes';
import { essentialsRoutes } from './features/essentials/routes';
import { questionsRoutes } from './features/questions/routes';
import { profileRoutes } from './features/profile/routes';
import { rolesRoutes } from './features/roles/routes';
import { usersRoutes } from './features/users/routes';

export const routes: Routes = [
  {
    path: APP_ROUTES.AUTH,
    loadComponent: () =>
      import('./layouts/auth-layout').then((m) => m.AuthLayout),
    children: [...authRoutes],
  },
  {
    path: APP_ROUTES.ROOT,
    redirectTo: APP_ROUTES.HOME,
    pathMatch: 'full',
  },
  {
    path: APP_ROUTES.ROOT,
    canMatch: [authGuard],
    loadComponent: () =>
      import('./layouts/dashboard-layout').then((m) => m.DashboardLayout),
    children: [
      {
        title: 'pagesTitles.home',
        path: APP_ROUTES.HOME,
        loadComponent: () => import('./features/home').then((m) => m.Home),
      },
      ...profileRoutes,
      ...usersRoutes,
      ...rolesRoutes,
      ...essentialsRoutes,
      ...evaluationsRoutes,
      ...questionsRoutes,
    ],
  },
  {
    title: 'pagesTitles.pageNotFound',
    path: '**',
    loadComponent: () =>
      import('./features/page-not-found/page-not-found').then(
        (m) => m.PageNotFound,
      ),
  },
];
